import z from 'zod';
import { Permission } from '@/model/access-control';
import { t } from '@/i18n';

export const accessControlPermissionTypeEditSchema = z.object({
  name: z.string().min(1, t('pages.access_control_permission_type_edit.schema.required') || ''),
  permissions: z
    .object({
      [Permission.HOME]: z.boolean(),
      [Permission.USERS]: z.boolean(),
      [Permission.SUBSCRIBERS]: z.boolean(),
      [Permission.ACCESS_PLANS]: z.boolean(),
      [Permission.APPLICATION]: z.boolean(),
      [Permission.FINANCIAL]: z.boolean(),
      [Permission.PARTNERS]: z.boolean(),
      [Permission.ACCESS_CONTROL]: z.boolean(),
      [Permission.COMMUNICATION_CENTRAL]: z.boolean(),
    })
    .refine(values => {
      const hasAtLeastOnePermission = Object.keys(values)
        .map(permission => values[permission])
        .some(permission => permission);

      return hasAtLeastOnePermission;
    }, t('pages.access_control_permission_type_edit.schema.required_permissions') || ''),
});

export type AccessControlPermissionTypeEditFormData = z.infer<typeof accessControlPermissionTypeEditSchema>;
